import { render, staticRenderFns } from "./TableQA.vue?vue&type=template&id=d9021ed6&"
import script from "./TableQA.vue?vue&type=script&lang=js&"
export * from "./TableQA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports